import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import client from './apollo/client';
import { theme } from './styles/theme';
import Navbar from './components/Navbar/Navbar';
import BlackFridayOverlay from './components/common/BlackFridayOverlay';
import Home from './components/pages/Home/Home';
import RetailVillage from './components/pages/Home/RetailVillage';
import DayTickets from './components/pages/DayTickets/DayTickets';
import BookTickets from './components/pages/BookTickets/BookTickets';
import SelectDate from './components/pages/SelectDate/SelectDate';
import EventDetail from './components/pages/EventDetail/EventDetail';
import CastleStateRooms from './components/pages/Home/CastleStateRooms';
import ScrollToTop from './utils/ScrollToTop';
import OpeningTimes from './components/pages/OpeningTimes/OpeningTimes';
import Directions from './components/pages/Directions/Directions';
import Accessibility from './components/pages/Accessibility/Accessibility';
import Groups from './components/pages/Groups/Groups';
import AfternoonTea from './components/pages/AfternoonTea/AfternoonTea';
import AviaryTearoom from './components/pages/AviaryTearoom/AviaryTearoom';
import Weddings from './components/pages/Weddings/Weddings';
import PrivateHire from './components/pages/PrivateHire/PrivateHire';
import History from './components/pages/History/History';
import AdventurePlayground from './components/pages/AdventurePlayground/AdventurePlayground';
import Gardens from './components/pages/Gardens/Gardens';
import CastleMapPage from './components/pages/CastleMap/CastleMapPage';
import GiftVouchers from './components/pages/GiftVouchers/GiftVouchers';
import Memberships from './components/pages/Memberships/Memberships';
import FarmShop from './components/pages/FarmShop/FarmShop';
import FarmShopShop from './components/pages/FarmShop/FarmShopShop';
import FarmShopProductDetail from './components/pages/FarmShop/FarmShopProductDetail';
import DuchessCollection from './components/pages/DuchessCollection/DuchessCollection';
import DuchessCollectionShop from './components/pages/DuchessCollection/DuchessCollectionShop';
import ProductDetail from './components/pages/DuchessCollection/ProductDetail';
import Checkout from './components/pages/DuchessCollection/Checkout';
import PaymentSuccess from './components/pages/DuchessCollection/PaymentSuccess';
import PaymentFailure from './components/pages/DuchessCollection/PaymentFailure';
import FarmShopCheckout from './components/pages/FarmShop/FarmShopCheckout';
import FarmShopPaymentSuccess from './components/pages/FarmShop/FarmShopPaymentSuccess';
import FarmShopPaymentFailure from './components/pages/FarmShop/FarmShopPaymentFailure';
import FarmShopNewsletter from './components/pages/FarmShop/FarmShopNewsletter';
import FarmShopOrderLookup from './components/pages/FarmShop/FarmShopOrderLookup';
import FarmShopOrderDetails from './components/pages/FarmShop/FarmShopOrderDetails';
import FarmShopTerms from './components/pages/FarmShop/FarmShopTerms';
import DuchessCollectionNewsletter from './components/pages/DuchessCollection/DuchessCollectionNewsletter';
import WooCommerceTest from './components/pages/DuchessCollection/WooCommerceTest';
import EnvTest from './components/pages/DuchessCollection/EnvTest';
import WooCommerceDiagnostic from './components/pages/DuchessCollection/WooCommerceDiagnostic';
import AuthMethodTest from './components/pages/DuchessCollection/AuthMethodTest';
import HeaderTest from './components/pages/DuchessCollection/HeaderTest';
import WooCommerceDebug from './components/pages/DuchessCollection/WooCommerceDebug';
import PaymentMethodChecker from './components/pages/DuchessCollection/PaymentMethodChecker';
import BelvoirPetShop from './components/pages/BelvoirPetShop/BelvoirPetShop';
import OutdoorLivingCollective from './components/pages/OutdoorLivingCollective/OutdoorLivingCollective';
import ChristmasHome from './components/pages/Christmas/ChristmasHome';
import SecurityCenter from './components/pages/Admin/SecurityCenter';
import AfternoonTeaBookingsPage from './components/pages/Admin/AfternoonTeaBookingsPage';
import DogParkBookingsPage from './components/pages/Admin/DogParkBookingsPage';
import ManageBooking from './components/pages/ManageBooking/ManageBooking';
import ErrorMonitoringTest from './components/pages/ErrorMonitoringTest/ErrorMonitoringTest';
import YourFestiveVisit from './components/pages/Christmas/YourFestiveVisit';
import YourFestiveVisitFAQs from './components/pages/Christmas/YourFestiveVisitFAQs';
import FestiveAfternoonTea from './components/pages/Christmas/FestiveAfternoonTea';
import SantasGrottoCastle from './components/pages/Christmas/SantasGrottoCastle';
import SantasGrottoOptions from './components/pages/Christmas/SantasGrottoOptions';
import SantasGrottoRetailVillageOptions from './components/pages/Christmas/SantasGrottoRetailVillageOptions';
import SearchForSanta from './components/pages/Christmas/SearchForSanta';
import MiceTrail from './components/pages/Christmas/MiceTrail';
import CastleByCandlelight from './components/pages/Christmas/CastleByCandlelight';
import ChristmasDayTickets from './components/pages/Christmas/ChristmasDayTickets';
import AntiquesMarket from './components/pages/AntiquesMarket/AntiquesMarket';
import AntiquesMarketRegister from './components/pages/AntiquesMarket/AntiquesMarketRegister';
import EasterTrail from './components/pages/EasterTrail/EasterTrail';
import MayDayBankHoliday from './components/pages/MayDayBankHoliday/MayDayBankHoliday';
import PirateTrail from './components/pages/PirateTrail/PirateTrail';

import Exhibitions from './components/pages/Exhibitions/Exhibitions';
import SeasonalActivities from './components/pages/SeasonalActivities/SeasonalActivities';
import FreeClubs from './components/pages/FreeClubs/FreeClubs';
import WhatsOn from './components/pages/WhatsOn/WhatsOn';
import Events from './components/pages/Events/Events';
import ShopsOverview from './components/pages/Shops/ShopsOverview';
import AnimalPark from './components/pages/AnimalPark/AnimalPark';
import RetailDining from './components/pages/RetailDining/RetailDining';
import BelvoirBistro from './components/pages/BelvoirBistro/BelvoirBistro';
import WoodfiredPizza from './components/pages/WoodfiredPizza/WoodfiredPizza';
import BalloonBar from './components/pages/BalloonBar/BalloonBar';
import Stay from './components/pages/Stay/Stay';
import Glamping from './components/pages/Stay/Glamping';
import Cottages from './components/pages/Stay/Cottages';
import Camping from './components/pages/Stay/Camping';
import ValeHouse from './components/pages/Stay/ValeHouse';
import Experiences from './components/pages/Experiences/Experiences';
import GettingHere from './components/pages/Stay/GettingHere';
import MembersArea from './components/pages/MembersArea/MembersArea';
import Parking from './components/pages/Parking/Parking';
import CastleDining from './components/pages/CastleDining/CastleDining';
import FeaturedTours from './components/pages/FeaturedTours/FeaturedTours';
import FilmLoversTour from './components/pages/FeaturedTours/FilmLoversTour';
import GardenTour from './components/pages/FeaturedTours/GardenTour';
import ArtCollectionTour from './components/pages/FeaturedTours/ArtCollectionTour';
import ButlerSawTour from './components/pages/FeaturedTours/ButlerSawTour';
import Tours from './components/pages/Tours/Tours';
import Journal from './components/pages/Journal/Journal';
import VineyardTour from './components/pages/VineyardTour/VineyardTour';
import BelvoirWellness from './components/pages/Wellness/BelvoirWellness';
import Terms from './components/pages/Legal/Terms';
import Privacy from './components/pages/Legal/Privacy';
import Cookies from './components/pages/Legal/Cookies';
import DronePolicy from './components/pages/Legal/DronePolicy';
import EventSafety from './components/pages/EventSafety/EventSafety';
import RetailVillageDirections from './components/pages/RetailVillageDirections/RetailVillageDirections';
import TourBooking from './components/pages/Tours/TourBooking';
import NewsletterTours from './components/pages/Tours/NewsletterTours';
import AfternoonTeaBooking from './components/pages/AfternoonTea/AfternoonTeaBooking';
import NewsletterAfternoonTea from './components/pages/AfternoonTea/NewsletterAfternoonTea';
import NewsletterFestiveAfternoonTea from './components/pages/AfternoonTea/NewsletterFestiveAfternoonTea';
import ExhibitionBooking from './components/pages/Exhibitions/ExhibitionBooking';
import VoucherRedemption from './components/pages/GiftVouchers/VoucherRedemption';
import BookingSelection from './components/pages/BookingSelection/BookingSelection';
import BookingJourney from './components/pages/BookingJourney/BookingJourney';
import ExplorerLunchBoxJourney from './components/pages/ExplorerLunchBox/ExplorerLunchBoxJourney';
import BookingJourney2 from './components/pages/BookingJourney2/BookingJourney2';
import BookingConfirmationPreview from './components/pages/BookingJourney/BookingConfirmationPreview';
import BookingError from './components/pages/BookingJourney/BookingError';
import EmailTicketPreview from './components/pages/EmailTicketPreview';
import TicketPage from './components/pages/BookingJourney/TicketPage';
import { BookingProvider } from './contexts/BookingContext';
import { DesignSubmissionsProvider } from './contexts/DesignSubmissionsContext';
import ChildrensArtSubmit from './components/pages/ChildrensArt/ChildrensArtSubmit';
import ChildrensArtGallery from './components/pages/ChildrensArt/ChildrensArtGallery';
import { HelmetProvider } from 'react-helmet-async';
import { initGA, logPageView, logEvent } from './utils/analytics';
import { initializeMetaPixel, trackPageView } from './utils/metaPixel';
import { initTracker, trackPageView as trackFirstPartyPageView } from './utils/firstPartyTracker';
import { BasketProvider } from './contexts/BasketContext';
import DogFriendly from './components/pages/DogFriendly/DogFriendly';
import DogPark from './components/pages/DogPark/DogPark';
import DogClubRegister from './components/pages/DogClub/DogClubRegister';
import BelvoirBooks from './components/pages/BelvoirBooks/BelvoirBooks';
import CookieBanner from './components/common/CookieBanner';
import useCastleSection from './hooks/useCastleSection';
import ClosureBanner from './components/common/ClosureBanner';
import ClosurePopup from './components/common/ClosurePopup';
import ChristmasMediumshipPopup from './components/common/ChristmasMediumshipPopup';
import NewYearsDayWalkPopup from './components/common/NewYearsDayWalkPopup';
import EventBanner from './components/common/EventBanner';
import ChristmasBookingBanner from './components/common/ChristmasBookingBanner';
import Careers from './components/pages/About/Careers';
import DigitalMarketingInternship from './components/pages/About/DigitalMarketingInternship';
import SoftwareDigitalDevelopment from './components/pages/About/SoftwareDigitalDevelopment';
import RuralEstateAssistant from './components/pages/About/RuralEstateAssistant';
import RetailSalesAssistant from './components/pages/About/RetailSalesAssistant';
import TarotReaderGypsy from './components/pages/About/TarotReaderGypsy';
import VolunteerGardenGuide from './components/pages/About/VolunteerGardenGuide';
import VolunteerCastleGuide from './components/pages/About/VolunteerCastleGuide';
import SocialMediaManager from './components/pages/About/SocialMediaManager';
import SocialMediaAssistant from './components/pages/About/SocialMediaAssistant';
import EventsOrganiser from './components/pages/About/EventsOrganiser';
import FaceOfBelvoir from './components/pages/FaceOfBelvoir/FaceOfBelvoir';
import WickedNight from './components/pages/Halloween/WickedNight';
import HalloweenTickets from './components/pages/Halloween/HalloweenTickets';
import HalloweenCrafts from './components/pages/Halloween/HalloweenCrafts';
import ResidentSignUp from './components/pages/Residents/ResidentSignUp';
import ChoirDiscount from './components/pages/ChoirDiscount/ChoirDiscount';
import NewsletterSignUp from './components/pages/Newsletter/NewsletterSignUp';
import { BlackFridayProvider } from './contexts/BlackFridayContext';
import SystemStatus from './components/pages/SystemStatus';
import CarolineScreen from './components/pages/CarolineScreen/CarolineScreen';

const App = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('castle');
  const enableBlackFridayMode = process.env.REACT_APP_BLACK_FRIDAY_MODE === 'true';
  const isChristmasRoute = location.pathname.startsWith('/christmas');
  const isBlackFridayActive = enableBlackFridayMode && isChristmasRoute;

  useEffect(() => {
    // Initialize GA with your measurement ID
    initGA(process.env.REACT_APP_GA_MEASUREMENT_ID);
    // Initialize first-party analytics tracker
    initTracker();
  }, []);

  useEffect(() => {
    // Log page view on route change
    logPageView();
    // First-party tracker page view
    trackFirstPartyPageView(location.pathname);
  }, [location]);

  useEffect(() => {
    // Initialize Meta Pixel
    initializeMetaPixel();
  }, []);

  useEffect(() => {
    // Track page views on route change
    trackPageView();
  }, [location]);

  useEffect(() => {
    if (isBlackFridayActive) {
      document.body.classList.add('black-friday-mode');
    } else {
      document.body.classList.remove('black-friday-mode');
    }

    return () => {
      document.body.classList.remove('black-friday-mode');
    };
  }, [isBlackFridayActive]);

  useCastleSection(setActiveSection);

  const hideNavRoutes = ['/print-ticket', '/choir-discount', '/admin', '/security-center', '/afternoon-tea-bookings', '/dog-park-bookings', '/manage-booking', '/caroline-screen', '/explore'];
  const shouldHideNav = hideNavRoutes.some(route => location.pathname.startsWith(route));
  const isExploreRoute = location.pathname.startsWith('/explore');
  const hideChromeOverlays =
    location.pathname.startsWith('/caroline-screen') || isExploreRoute;
  const hideEventBanner =
    location.pathname.startsWith('/booking-journey') ||
    location.pathname.startsWith('/booking-journey2') ||
    location.pathname === '/print-ticket' ||
    location.pathname.startsWith('/afternoon-tea-bookings') ||
    location.pathname.startsWith('/dog-park-bookings') ||
    location.pathname.startsWith('/manage-booking') ||
    location.pathname.startsWith('/caroline-screen') ||
    location.pathname.startsWith('/explorer-lunch-box') ||
    isExploreRoute;

  return (
    <HelmetProvider>
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <BlackFridayProvider isActive={isBlackFridayActive}>
            <DesignSubmissionsProvider>
            <BasketProvider>
              <ScrollToTop />
              {isBlackFridayActive && <BlackFridayOverlay />}
              {!shouldHideNav && <Navbar />}
              <Routes>
            {/* Legacy URL Redirects */}
            <Route path="/castle-plan-your-day-out" element={<Navigate to="/your-visit" replace />} />
            <Route path="/castle-faqs" element={<Navigate to="/your-visit" replace />} />
            <Route path="/homepage-before-image-resizes" element={<Navigate to="/" replace />} />
            <Route path="/contact" element={<Navigate to="/your-visit" replace />} />
            <Route path="/join-friends-of-belvoir-castle" element={<Navigate to="/memberships" replace />} />
            <Route path="/terms-and-conditions" element={<Navigate to="/terms" replace />} />
            <Route path="/book-tickets-afternoon-tea" element={<Navigate to="/castle-dining/afternoon-tea" replace />} />
            <Route path="/aviary-tearoom" element={<Navigate to="/castle-dining/aviary-tearoom" replace />} />
            
            {/* Christmas URL Redirects */}
            <Route path="/events/christmas-at-the-castle" element={<Navigate to="/christmas" replace />} />
            <Route path="/event/cG9zdDoxNTI=" element={<Navigate to="/christmas" replace />} />

            {/* Halloween URL Redirects */}
            <Route path="/events/halloween-trail" element={<Navigate to="/halloween-belvoir-castle" replace />} />

            {/* Home */}
            <Route path="/" element={<Home />} />
            {/* Castle landing page (accessible via top nav) */}
            <Route path="/castle" element={<Home />} />
            
            {/* Christmas Section */}
            <Route path="/christmas" element={<ChristmasHome />} />
            <Route path="/christmas/your-festive-visit" element={<YourFestiveVisit />} />
            <Route path="/christmas/your-festive-visit/faqs" element={<YourFestiveVisitFAQs />} />
            <Route path="/christmas/wreath-making" element={<Navigate to="/christmas" replace />} />
            <Route path="/christmas/mice-trail" element={<MiceTrail />} />
            <Route path="/christmas/festive-afternoon-tea" element={<FestiveAfternoonTea />} />
            <Route path="/christmas/santas-grotto" element={<Navigate to="/christmas/santas-grotto-options" replace />} />
            <Route path="/christmas/santas-grotto-castle" element={<SantasGrottoCastle />} />
            <Route path="/christmas/santas-grotto-options" element={<SantasGrottoOptions />} />
            <Route path="/christmas/santas-grotto-retail-village-options" element={<SantasGrottoRetailVillageOptions />} />
            <Route path="/christmas/search-for-santa" element={<SearchForSanta />} />
            <Route path="/christmas/castle-by-candlelight" element={<CastleByCandlelight />} />
            <Route path="/christmas/tickets" element={<ChristmasDayTickets />} />
            
            {/* Your Visit Section */}
            <Route path="/your-visit" element={<DayTickets />} />
            <Route path="/your-visit/day-tickets" element={<DayTickets />} />
            <Route path="/your-visit/opening-times" element={<OpeningTimes />} />
            <Route path="/your-visit/directions" element={<Directions />} />
            <Route path="/your-visit/accessibility" element={<Accessibility />} />
            <Route path="/your-visit/tours" element={<Tours />} />
            <Route path="/your-visit/groups" element={<Groups />} />
            <Route path="/your-visit/event-safety" element={<EventSafety />} />
            
            {/* Castle Dining Section */}
            <Route path="/castle-dining" element={<CastleDining />} />
            <Route path="/castle-dining/aviary-tearoom" element={<AviaryTearoom />} />
            <Route path="/castle-dining/afternoon-tea" element={<AfternoonTea />} />
            <Route path="/castle-dining/afternoon-tea-booking" element={<AfternoonTeaBooking />} />
            <Route path="/manage-booking" element={<ManageBooking />} />
            
            {/* What's On Section */}
            <Route path="/whats-on" element={<WhatsOn />} />
            <Route path="/whats-on/events" element={<Events />} />
            <Route path="/whats-on/exhibitions" element={<Exhibitions />} />
            <Route path="/whats-on/featured-tours" element={<FeaturedTours />} />
            <Route path="/featured-tours/film-lovers" element={<FilmLoversTour />} />
            <Route path="/featured-tours/garden-tour" element={<GardenTour />} />
            <Route path="/featured-tours/art-collection" element={<ArtCollectionTour />} />
            <Route path="/featured-tours/butler-saw" element={<ButlerSawTour />} />
            <Route path="/whats-on/vineyard-tour" element={<VineyardTour />} />
            <Route path="/whats-on/belvoir-wellness" element={<BelvoirWellness />} />
            <Route path="/wellness" element={<Navigate to="/whats-on/belvoir-wellness" replace />} />
            <Route path="/whats-on/seasonal-activities" element={<SeasonalActivities />} />
            <Route path="/whats-on/free-clubs-and-classes" element={<FreeClubs />} />
            <Route path="/easter-trail" element={<EasterTrail />} />
            <Route path="/may-day-bank-holiday" element={<MayDayBankHoliday />} />
            <Route path="/pirate-trail" element={<PirateTrail />} />
            <Route path="/whats-on/exhibition-booking" element={<ExhibitionBooking />} />

            {/* Children's Art Gallery */}
            <Route path="/childrens-art-gallery" element={<ChildrensArtGallery />} />
            <Route path="/childrens-art-gallery/submit" element={<ChildrensArtSubmit />} />
            
            {/* Experiences Section */}
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/getting-here" element={<GettingHere />} />
            <Route path="/stay" element={<Stay />} />
            <Route path="/accommodations" element={<Stay />} />
            <Route path="/accommodations/rooms" element={<Stay />} />
            <Route path="/accommodations/vale-house" element={<ValeHouse />} />
            <Route path="/accommodations/cottages" element={<Cottages />} />
            <Route path="/accommodations/camping" element={<Camping />} />
            <Route path="/accommodations/glamping" element={<Glamping />} />
            <Route path="/booking" element={<Stay />} />
            <Route path="/weddings" element={<Weddings />} />
            <Route path="/private-hire" element={<PrivateHire />} />
            
            {/* About Section */}
            <Route path="/about" element={<CastleStateRooms />} />
            <Route path="/about/castle-and-state-rooms" element={<CastleStateRooms />} />
            <Route path="/about/history" element={<History />} />
            <Route path="/about/gardens" element={<Gardens />} />
            <Route path="/explore" element={<CastleMapPage />} />
            <Route path="/about/adventure-playground" element={<AdventurePlayground />} />
            <Route path="/about/careers" element={<Careers />} />
            <Route path="/about/careers/digital-marketing-graduate" element={<DigitalMarketingInternship />} />
            <Route path="/about/careers/digital-marketing-intern" element={<Navigate to="/about/careers/digital-marketing-graduate" replace />} />
            <Route path="/about/careers/software-digital-graduate" element={<SoftwareDigitalDevelopment />} />
            <Route path="/about/careers/rural-estate-assistant" element={<RuralEstateAssistant />} />
            <Route path="/about/careers/retail-sales-assistant" element={<RetailSalesAssistant />} />
            <Route path="/about/careers/tarot-reader-gypsy-caravan" element={<TarotReaderGypsy />} />
            <Route path="/about/careers/volunteer-garden-guide" element={<VolunteerGardenGuide />} />
            <Route path="/about/careers/volunteer-castle-guide" element={<VolunteerCastleGuide />} />
            <Route path="/about/careers/social-media-manager" element={<SocialMediaManager />} />
            <Route path="/about/careers/social-media-assistant" element={<SocialMediaAssistant />} />
            <Route path="/about/careers/marketing-assistant" element={<Navigate to="/about/careers/social-media-manager" replace />} />
            <Route path="/about/careers/events-organiser" element={<EventsOrganiser />} />
            <Route path="/face-of-belvoir" element={<FaceOfBelvoir />} />
            <Route path="/summer-safari" element={<Navigate to="/your-visit/day-tickets" replace />} />
            <Route path="/belvoir-summer-safari" element={<Navigate to="/your-visit/day-tickets" replace />} />
            <Route path="/belvoir-summer-safari/tickets" element={<Navigate to="/your-visit/day-tickets" replace />} />
            {/* Halloween */}
            <Route path="/halloween-belvoir-castle" element={<WickedNight />} />
            <Route path="/halloween-belvoir-castle/tickets" element={<HalloweenTickets />} />
            <Route path="/halloween-crafts" element={<HalloweenCrafts />} />
            <Route path="/belvoir-wicked-night" element={<Navigate to="/halloween-belvoir-castle" replace />} />
            <Route path="/belvoir-wicked-night/tickets" element={<Navigate to="/halloween-belvoir-castle/tickets" replace />} />
            <Route path="/halloween-belvoir-castle/crafts" element={<Navigate to="/halloween-crafts" replace />} />
            <Route path="/about/gift-vouchers" element={<GiftVouchers />} />
            <Route path="/about/parking" element={<Parking />} />
            <Route path="/about/dog-friendly" element={<DogFriendly />} />
            <Route path="/dog-park" element={<DogPark />} />
            <Route path="/about/dog-park" element={<Navigate to="/dog-park" replace />} />
            <Route path="/dog-club" element={<DogClubRegister />} />
            <Route path="/about/belvoir-books" element={<BelvoirBooks />} />
            <Route path="/about/books" element={<Navigate to="/about/belvoir-books" replace />} />
           
            {/* Retail Section */}
            <Route path="/retail-village" element={<RetailVillage />} />
            <Route path="/retail-village/shops" element={<ShopsOverview />} />
            <Route path="/retail-village/shops/farm-shop" element={<FarmShop />} />
            <Route path="/retail-village/shops/farm-shop/shop" element={<FarmShopShop />} />
            <Route path="/retail-village/shops/farm-shop/product/:id" element={<FarmShopProductDetail />} />
            <Route path="/farm-shop" element={<FarmShopShop />} />
            <Route path="/farm-shop/product/:id" element={<FarmShopProductDetail />} />
            <Route path="/farm-shop/checkout" element={<FarmShopCheckout />} />
            <Route path="/farm-shop/checkout/success" element={<FarmShopPaymentSuccess />} />
            <Route path="/farm-shop/checkout/failure" element={<FarmShopPaymentFailure />} />
            <Route path="/farm-shop/newsletter" element={<FarmShopNewsletter />} />
            <Route path="/farm-shop/order" element={<FarmShopOrderLookup />} />
            <Route path="/farm-shop/order/view" element={<FarmShopOrderDetails />} />
            <Route path="/farm-shop/terms" element={<FarmShopTerms />} />
            <Route path="/retail-village/shops/duchess-collection" element={<DuchessCollection />} />
            <Route path="/retail-village/shops/duchess-collection/shop" element={<DuchessCollectionShop />} />
            <Route path="/duchess-collection" element={<DuchessCollectionShop />} />
            <Route path="/duchess-collection/product/:id" element={<ProductDetail />} />
            <Route path="/duchess-collection/checkout" element={<Checkout />} />
            <Route path="/duchess-collection/checkout/success" element={<PaymentSuccess />} />
            <Route path="/duchess-collection/checkout/failure" element={<PaymentFailure />} />
            <Route path="/duchess-collection/newsletter" element={<DuchessCollectionNewsletter />} />
            <Route path="/retail-village/shops/duchess-collection/test" element={<WooCommerceTest />} />
            <Route path="/retail-village/shops/duchess-collection/env-test" element={<EnvTest />} />
            <Route path="/retail-village/shops/duchess-collection/diagnostic" element={<WooCommerceDiagnostic />} />
            <Route path="/retail-village/shops/duchess-collection/auth-test" element={<AuthMethodTest />} />
            <Route path="/retail-village/shops/duchess-collection/header-test" element={<HeaderTest />} />
            <Route path="/retail-village/shops/duchess-collection/debug" element={<WooCommerceDebug />} />
            <Route path="/retail-village/shops/duchess-collection/payment-methods" element={<PaymentMethodChecker />} />
            <Route path="/retail-village/shops/belvoir-pet-shop" element={<BelvoirPetShop />} />
            <Route path="/retail-village/shops/tori-murphy" element={<Navigate to="/retail-village/shops/belvoir-pet-shop" replace />} />
            <Route path="/retail-village/shops/outdoor-living-collective" element={<OutdoorLivingCollective />} />

            <Route path="/retail-village/animal-park" element={<AnimalPark />} />
            <Route path="/retail-village/dining" element={<RetailDining />} />
            <Route path="/retail-village/dining/belvoir-bistro" element={<BelvoirBistro />} />
            <Route path="/retail-village/dining/woodfired-pizza" element={<WoodfiredPizza />} />
            <Route path="/retail-village/dining/balloon-bar" element={<BalloonBar />} />
            <Route path="/retail-village/directions" element={<RetailVillageDirections />} />
            
            {/* Other Routes */}
            <Route path="/book-tickets" element={<BookTickets />} />
            <Route path="/select-date" element={<SelectDate />} />
            <Route path="/explorer-lunch-box" element={<ExplorerLunchBoxJourney />} />
            <Route path="/booking-journey" element={
              <BookingProvider>
                <BookingJourney />
              </BookingProvider>
            } />
            <Route path="/booking-journey2" element={
              <BookingProvider>
                <BookingJourney2 />
              </BookingProvider>
            } />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route path="/events/antiques-artisan-market/register" element={<AntiquesMarketRegister />} />
            <Route path="/events/antiques-artisan-market" element={<AntiquesMarket />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/memberships" element={<Memberships />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:postId" element={<Journal />} />
            {/* Security Centre */}
            <Route path="/security-center" element={<SecurityCenter />} />
            
            {/* Afternoon Tea Bookings - Direct Access */}
            <Route path="/afternoon-tea-bookings" element={<AfternoonTeaBookingsPage />} />
            <Route path="/dog-park-bookings" element={<DogParkBookingsPage />} />
            
            {/* System Status */}
            <Route path="/status" element={<SystemStatus />} />

            {/* Caroline Screen - full-screen slideshow, no nav */}
            <Route path="/caroline-screen" element={<CarolineScreen />} />
            
            {/* Legal Pages */}
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<Cookies />} />
            <Route path="/drone-policy" element={<DronePolicy />} />
            
            {/* Legacy Routes - keeping for backward compatibility */}
            <Route path="/day-tickets" element={<DayTickets />} />
            <Route path="/castle-and-state-rooms" element={<CastleStateRooms />} />
            <Route path="/castle-and-state-rooms/history" element={<CastleStateRooms />} />
            <Route path="/castle-and-state-rooms/architecture" element={<CastleStateRooms />} />
            <Route path="/castle-and-state-rooms/collections" element={<CastleStateRooms />} />
            
            {/* Members Area */}
            <Route path="/members-area" element={<MembersArea />} />
            
            {/* Catch-all route - redirect to home */}
            <Route path="*" element={<Home />} />
            
            {/* New route */}
            <Route path="/tour-booking" element={<TourBooking />} />
            <Route path="/newsletter-tours" element={<NewsletterTours />} />
            <Route path="/newsletter-afternoon-tea" element={<NewsletterAfternoonTea />} />
            <Route path="/newsletter-festive-afternoon-tea" element={<NewsletterFestiveAfternoonTea />} />
            <Route path="/newsletter-sign-up" element={<NewsletterSignUp />} />
            <Route path="/voucher-redemption" element={<VoucherRedemption />} />
            <Route path="/booking-selection" element={<BookingSelection />} />
            <Route path="/resident-sign-up" element={<ResidentSignUp />} />
            <Route path="/choir-discount" element={<ChoirDiscount />} />
            
            {/* Test/Preview Routes */}
            <Route path="/booking-confirmation-test" element={<BookingConfirmationPreview />} />
            <Route path="/booking-error" element={<BookingError />} />
            <Route path="/email-ticket-preview" element={<EmailTicketPreview />} />
            <Route path="/print-ticket" element={<TicketPage />} />
            <Route path="/admin/error-monitoring-test" element={<ErrorMonitoringTest />} />
              </Routes>
              {!location.pathname.startsWith('/caroline-screen') && !isExploreRoute && <CookieBanner />}
          {!hideEventBanner && (
            <>
              {/* <ClosureBanner /> */}
              <EventBanner />
            </>
          )}
          {/* <ChristmasBookingBanner /> */}
              {/* <ClosurePopup /> */}
              {!hideChromeOverlays && <ChristmasMediumshipPopup />}
              {!hideChromeOverlays && <NewYearsDayWalkPopup />}
          {/* Bonfire popups removed */}
            </BasketProvider>
            </DesignSubmissionsProvider>
          </BlackFridayProvider>
        </ThemeProvider>
      </ApolloProvider>
    </HelmetProvider>
  );
};

export default App;
